import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet10 = css`
:host {
}
    .image__facet-10 {
        ::slotted(img), ::slotted(picture) {
            object-fit: cover;
            clip-path: polygon( 33.264% 0%,0% 16.585%,0% 78.515%,0% 78.515%,0.6% 83.271%,2.3% 87.582%,4.95% 91.372%,8.4% 94.568%,12.5% 97.094%,17.099% 98.878%,22.049% 99.844%,27.199% 99.918%,32.399% 99.026%,37.499% 97.093%,87.882% 72.13%,87.882% 72.13%,90.044% 70.923%,92.022% 69.544%,93.807% 68.006%,95.387% 66.326%,96.753% 64.519%,97.894% 62.601%,98.8% 60.586%,99.46% 58.492%,99.863% 56.332%,100% 54.123%,100% 33.063%,33.264% 0% );
            aspect-ratio: 1;
            width: 100%;
            height: auto;
            z-index: 2;
        }
        .image-shapes-10, .image-shapes-10-overlay {
            display: block;
        }
        .image-shapes-10--crop-mobile {
            display: none;
        }
    }

    .image__facet-10--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 0% 0%,0% 66.619%,0% 66.619%,0.6% 74.008%,2.3% 80.705%,4.95% 86.594%,8.4% 91.559%,12.5% 95.485%,17.1% 98.256%,22.05% 99.757%,27.2% 99.873%,32.4% 98.487%,37.5% 95.485%,87.883% 56.7%,87.883% 56.7%,90.044% 54.826%,92.022% 52.682%,93.807% 50.293%,95.387% 47.683%,96.753% 44.875%,97.894% 41.893%,98.8% 38.763%,99.46% 35.508%,99.863% 32.152%,100% 28.719%,100% 0%,0% 0% );
        }
        .image-shapes-10, .image-shapes-10-overlay {
            display: none;
        }
        .image-shapes-10--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                aspect-ratio: 1;
                clip-path: polygon( 33.264% 0%,0% 16.585%,0% 78.515%,0% 78.515%,0.6% 83.271%,2.3% 87.582%,4.95% 91.372%,8.4% 94.568%,12.5% 97.094%,17.099% 98.878%,22.049% 99.844%,27.199% 99.918%,32.399% 99.026%,37.499% 97.093%,87.882% 72.13%,87.882% 72.13%,90.044% 70.923%,92.022% 69.544%,93.807% 68.006%,95.387% 66.326%,96.753% 64.519%,97.894% 62.601%,98.8% 60.586%,99.46% 58.492%,99.863% 56.332%,100% 54.123%,100% 33.063%,33.264% 0% );
            }
            .image-shapes-10, .image-shapes-10-overlay {
                display: block;
            }
            .image-shapes-10--crop-mobile {
                display: none;
            }
        }
    }

    .image-shapes-10 {
        position: absolute;
        top: 4%;
        left: -8%;
        width: 118%;
        height: auto;
        z-index: 1;
    }

    .image-shapes-10-overlay {
        position: absolute;
        top: 5.8%;
        left: 0;
        width: 115%;
        height: auto;
        z-index: 3;
    }

    .image-shapes-10--crop-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 3;
    }
`;